import { useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { langHelper } from "@newLibs/utils";
import { HistoryPushType, useRoute } from "@newHooks/route/useRoute";
import { LoLang } from "@maven-rest/common/common.types";
import { HttpRequest } from "@maven-rest/common/HttpRequest";

export const enum MvnLanguageText {
  EN = "English",
  KO = "한국어",
}

export const getBrowserDefaultLanguage = () => {
  switch (navigator.language.toLocaleLowerCase()) {
    case "ko":
    case "ko-kr":
      return LoLang.KO;
    default:
      return LoLang.EN;
  }
};

export function useHeader() {
  const loLang = langHelper.getLang();
  const history = useHistory();
  const { pathWithQuery } = useRoute();

  useEffect(() => {
    if (loLang) {
      HttpRequest.setAdditionalHeaders({ Lang: loLang || LoLang.EN });
    } else {
      langHelper.setLang(getBrowserDefaultLanguage());
    }
  }, [loLang]);

  const handleChangeLocaleLanguage = useCallback(
    (language: LoLang) => {
      langHelper.setLang(language);
      history.replace(pathWithQuery, { _forceKey: Math.random(), type: HistoryPushType.Language_Changed });
    },
    [history, pathWithQuery]
  );

  return {
    handleChangeLocaleLanguage,
  };
}
